import { env } from './runtime'

// we may wana move it to a separate folder if it grows too much
export const DEFAULT_AVATAR =
  'https://simplifyy-media.s3.us-east-2.amazonaws.com/32d1497703b65927d51e8933c1f90d12'
export const PORTAL_LINKS = {
  property: 'https://dlprealty.appfolio.com/properties/',
}
export const MAP_LINK = 'https://www.google.com/maps/search/?api=1&query='
export const DEFAULT_NO_OF_ROWS = 20
export const DEFAULT_SESSION_HISTORY_DAYS = 7

export const TWILLIO_ACCESS_TOKEN_EXP = 60000 // in ms
export const LINK_TREE_URL = `${env('web_public_url')}`
